/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import EventsControllerDtoNoticeListImageData from './EventsControllerDtoNoticeListImageData';

/**
 * The EventsControllerDtoNoticeListNoticeData model module.
 * @module model/EventsControllerDtoNoticeListNoticeData
 * @version 1.0
 */
class EventsControllerDtoNoticeListNoticeData {
    /**
     * Constructs a new <code>EventsControllerDtoNoticeListNoticeData</code>.
     * @alias module:model/EventsControllerDtoNoticeListNoticeData
     */
    constructor() { 
        
        EventsControllerDtoNoticeListNoticeData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoNoticeListNoticeData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoNoticeListNoticeData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoNoticeListNoticeData} The populated <code>EventsControllerDtoNoticeListNoticeData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoNoticeListNoticeData();

            if (data.hasOwnProperty('noticeNo')) {
                obj['noticeNo'] = ApiClient.convertToType(data['noticeNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('deeplink')) {
                obj['deeplink'] = ApiClient.convertToType(data['deeplink'], 'String');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
            if (data.hasOwnProperty('sortingIndex')) {
                obj['sortingIndex'] = ApiClient.convertToType(data['sortingIndex'], 'Number');
            }
            if (data.hasOwnProperty('imageFileName')) {
                obj['imageFileName'] = ApiClient.convertToType(data['imageFileName'], 'String');
            }
            if (data.hasOwnProperty('cache')) {
                obj['cache'] = ApiClient.convertToType(data['cache'], 'Number');
            }
            if (data.hasOwnProperty('noticeInfo')) {
                obj['noticeInfo'] = ApiClient.convertToType(data['noticeInfo'], 'String');
            }
            if (data.hasOwnProperty('noticeType')) {
                obj['noticeType'] = ApiClient.convertToType(data['noticeType'], 'Number');
            }
            if (data.hasOwnProperty('imageUrls')) {
                obj['imageUrls'] = ApiClient.convertToType(data['imageUrls'], [EventsControllerDtoNoticeListImageData]);
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoNoticeListNoticeData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoNoticeListNoticeData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['deeplink'] && !(typeof data['deeplink'] === 'string' || data['deeplink'] instanceof String)) {
            throw new Error("Expected the field `deeplink` to be a primitive type in the JSON string but got " + data['deeplink']);
        }
        // ensure the json data is a string
        if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
            throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
        }
        // ensure the json data is a string
        if (data['imageFileName'] && !(typeof data['imageFileName'] === 'string' || data['imageFileName'] instanceof String)) {
            throw new Error("Expected the field `imageFileName` to be a primitive type in the JSON string but got " + data['imageFileName']);
        }
        // ensure the json data is a string
        if (data['noticeInfo'] && !(typeof data['noticeInfo'] === 'string' || data['noticeInfo'] instanceof String)) {
            throw new Error("Expected the field `noticeInfo` to be a primitive type in the JSON string but got " + data['noticeInfo']);
        }
        if (data['imageUrls']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['imageUrls'])) {
                throw new Error("Expected the field `imageUrls` to be an array in the JSON data but got " + data['imageUrls']);
            }
            // validate the optional field `imageUrls` (array)
            for (const item of data['imageUrls']) {
                EventsControllerDtoNoticeListImageData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} noticeNo
 */
EventsControllerDtoNoticeListNoticeData.prototype['noticeNo'] = undefined;

/**
 * @member {String} title
 */
EventsControllerDtoNoticeListNoticeData.prototype['title'] = undefined;

/**
 * @member {String} deeplink
 */
EventsControllerDtoNoticeListNoticeData.prototype['deeplink'] = undefined;

/**
 * @member {String} region
 */
EventsControllerDtoNoticeListNoticeData.prototype['region'] = undefined;

/**
 * @member {Date} beginDate
 */
EventsControllerDtoNoticeListNoticeData.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
EventsControllerDtoNoticeListNoticeData.prototype['endDate'] = undefined;

/**
 * @member {Date} createAt
 */
EventsControllerDtoNoticeListNoticeData.prototype['createAt'] = undefined;

/**
 * @member {Number} sortingIndex
 */
EventsControllerDtoNoticeListNoticeData.prototype['sortingIndex'] = undefined;

/**
 * @member {String} imageFileName
 */
EventsControllerDtoNoticeListNoticeData.prototype['imageFileName'] = undefined;

/**
 * @member {Number} cache
 */
EventsControllerDtoNoticeListNoticeData.prototype['cache'] = undefined;

/**
 * @member {String} noticeInfo
 */
EventsControllerDtoNoticeListNoticeData.prototype['noticeInfo'] = undefined;

/**
 * @member {Number} noticeType
 */
EventsControllerDtoNoticeListNoticeData.prototype['noticeType'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoNoticeListImageData>} imageUrls
 */
EventsControllerDtoNoticeListNoticeData.prototype['imageUrls'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoNoticeListNoticeData.prototype['enabled'] = undefined;






export default EventsControllerDtoNoticeListNoticeData;

